<template>
  <div class="face-recognition">
    <el-card class="box-card">
      <!-- 标题 -->
      <h2 class="title">人脸识别中...</h2>

      <!-- 摄像头显示区域 -->
      <div class="video-container">
        <video ref="video" autoplay></video>
        <div v-if="loading" class="loading-overlay">
          <el-icon class="loading-icon"><Loading /></el-icon>
          <span>正在识别，请稍候...</span>
        </div>
      </div>

      <!-- 操作按钮 -->
      <div class="button-container">
        <el-button
            type="danger"
            @click="handleClose"
            :disabled="loading"
        >
          取消
        </el-button>
        <el-button
            type="primary"
            @click="handleRetry"
            :loading="loading"
        >
          识别
        </el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import axios from '@/axios';
import { ElMessage } from "element-plus";
import { Loading } from '@element-plus/icons-vue';

export default {
  props: {
    userid: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: false, // 识别过程加载状态
      stream: null,   // 摄像头流对象
    };
  },
  mounted() {
    this.startCamera();
  },
  methods: {
    // 启动摄像头
    async startCamera() {
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({video: true});
        this.$refs.video.srcObject = this.stream;
      } catch (err) {
        console.error("摄像头启动失败:", err);
        ElMessage.error("无法访问摄像头！");
        this.$emit("close", false); // 识别失败，关闭组件
      }
    },

    // 重新识别按钮
    handleRetry() {
      this.handleRecognition();
    },

    // 进行人脸识别
    async handleRecognition() {
      this.loading = true;
      try {
        const video = this.$refs.video;
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        // 截取当前帧
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(async (blob) => {
          const formData = new FormData();
          formData.append("image", blob, "image.jpg");
          formData.append("userid", this.userid);

          // 上传到后端进行识别
          const response = await axios.post("/images/recognize", formData);
          if (response.data.success) {
            ElMessage.success("人脸识别成功！");
            this.$emit("close", true); // 成功后关闭组件
          } else {
            ElMessage.error(response.data.errorMsg || "识别失败，请重试！");
          }
        }, "image/jpeg");
      } catch (error) {
        console.error("识别过程出错:", error);
        ElMessage.error("识别失败，请检查网络连接！");
      } finally {
        this.loading = false;
      }
    },

    // 关闭摄像头并退出
    handleClose() {
      this.stopCamera();
      this.$emit("close", false);
    },

    // 停止摄像头
    stopCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop());
      }
    }
  },
  beforeUnmount() {
    this.stopCamera();
  }
};
</script>

<style scoped>
.face-recognition {
  max-width: 600px;
  margin: 0 auto;
}

.title {
  text-align: center;
  color: #409eff;
  font-size: 1.5em;
  margin-bottom: 15px;
}

.video-container {
  position: relative;
  width: 100%;
  height: 300px;
  background-color: #000;
  border-radius: 8px;
  overflow: hidden;
}

.video-container video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.loading-icon {
  font-size: 2em;
  margin-bottom: 10px;
}

.button-container {
  margin-top: 20px;
  text-align: center;
}

.el-button {
  margin: 0 10px;
}
</style>
